var PES = PES || {};
PES.FadeCarouselSlider = function () {

    function fadeSlider() {

        var slideItem = $(".ppt__slide--handler.active").find(".slide__image").toArray();
        var currentSlide = 0;
        var interval = 6000;
        var slideIndicator = $(".ppt__slide--handler.active").find(".slide__thumb").toArray();
        var intervalReference;

        setTimeout(moveSlide, 10);

        function startAnimation() {
            clearInterval(intervalReference);
            intervalReference = setInterval(moveSlide, interval);
        }

        function moveSlide() {

            if (!$(slideItem[currentSlide]).hasClass("active") || !$(slideIndicator[currentSlide]).hasClass("active")) {
                $(slideItem[currentSlide]).addClass("active").siblings().removeClass("active");
                $(slideIndicator[currentSlide]).addClass("active").siblings().removeClass("active");
            }

            currentSlide++;

            if (currentSlide > slideItem.length - 1) {
                currentSlide = 0;
            }
        }
        $(".image-area .ppt-slide-container .slide__image").on("click", function () {
            $(".ppt__slide--handler.normal_slider").removeClass("active");
            $(".ppt__slide--handler.modal_slider").addClass("active");
            fadeSlider();
        });

        $(slideIndicator).on("click", function () {
            currentSlide = $(this).attr("data-position");
            moveSlide();
            startAnimation();
        });
        startAnimation();
    }


    var init = function () {
        fadeSlider();
    };

    return {
        init: init
    };
}();